import React from "react";
import Header from "../Landing/components/Header";
import Footer from "../Landing/components/Footer";
import termStyles from './TermConditionPage.module.css';
import styles from '../Landing/LandingPage.module.css';

const TermsAndConditions = () => {
    return (
        <>
            <Header />
            <main>
                <section className={`${termStyles.hero} ${termStyles.heroPrivacy}`}>
                    <div className={styles.container}>
                        <div className={termStyles.heroContent}>
                            <h1>Terms & Conditions</h1>
                            {/* <p>We're here to help you with any questions about posting jobs, finding professionals, or using our platform.</p> */}
                        </div>
                    </div>
                </section>
                
                <section className={termStyles.privacyWrapper}>
                    <div className={termStyles.privacyContainer}>

                        <p className={termStyles.lastUpdated}>
                            Last Updated: May 2026
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>1. Acceptance of Terms</h2>

                        <p>
                            By downloading, installing, or using the Build Start app or website (
                            <a
                                href="https://buildstart.au"
                                target="_blank"
                                rel="noreferrer"
                                className={termStyles.link}
                            >
                                buildstart.au
                            </a>
                            ), you agree to be bound by these Terms and Conditions.
                            If you do not agree, you must cease using our services immediately.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>2. Nature of Service</h2>

                        <p>
                            Build Start provides a directory and matching platform.
                            We facilitate connections between users seeking construction
                            services ("Users") and service providers ("Pros").
                        </p>

                        <ul>
                            <li>
                                <strong>No Agency:</strong> Build Start is not a party
                                to any contract, agreement, or arrangement between a User
                                and a Pro.
                            </li>

                            <li>
                                <strong>No Warranty of Work:</strong> We do not guarantee
                                the quality, safety, or legality of the work performed by Pros.
                                Any dispute regarding services must be resolved directly
                                between the User and the Pro.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>3. User Obligations</h2>

                        <ul>
                            <li>
                                You must be at least 18 years old to create an account.
                            </li>

                            <li>
                                You agree to provide accurate and truthful information.
                            </li>

                            <li>
                                Users are responsible for conducting their own due diligence
                                before hiring a Pro.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>4. Professional (Pro) Obligations</h2>

                        <ul>
                            <li>
                                Pros must maintain all necessary Australian licences,
                                registrations, and insurance policies required by law.
                            </li>

                            <li>
                                Verified Pro status is subject to ongoing review and can
                                be revoked if documentation expires or standards are not met.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>5. Fees and Payments</h2>

                        <p>
                            Build Start is currently free for Homeowner / Developer Users.
                            Service provider Pros pay a subscription or lead fee based on
                            their selected plan.
                        </p>

                        <p>
                            We do not process payments for construction work.
                            All financial transactions occur directly between the User
                            and the Pro outside the Build Start platform.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>6. Limitation of Liability</h2>

                        <p>
                            To the maximum extent permitted by Australian Consumer Law,
                            Build Start is not liable for any direct, indirect,
                            or consequential loss, property damage, or personal injury
                            arising from your use of the platform.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>7. Intellectual Property</h2>

                        <p>
                            All content, logos, and software are the property of Build Start.
                            By uploading photos, you grant us a non-exclusive,
                            royalty-free licence to use them for platform promotion.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>8. Termination</h2>

                        <p>
                            We reserve the right to suspend or terminate any account
                            that violates these terms, provides fraudulent information,
                            or brings the platform into disrepute.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>9. Governing Law</h2>

                        <p>
                            These terms are governed by the laws of Australia.
                            Any disputes will be subject to the exclusive jurisdiction
                            of the courts in that State.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>10. Refunds (for Professionals)</h2>

                        <ul>
                            <li>
                                <strong>No Pro-Rata Refunds:</strong> Subscription fees
                                are billed in advance. Cancelling during a billing cycle
                                will not result in a partial refund.
                            </li>

                            <li>
                                <strong>Change of Mind:</strong> We do not offer refunds
                                for change of mind or if a Pro fails to secure a contract.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>11. Dispute Resolution</h2>

                        <ul>
                            <li>
                                <strong>Between Users and Pros:</strong> We are not mediators.
                                Disputes regarding work quality must be handled between
                                the User and the Pro.
                            </li>

                            <li>
                                <strong>Disputes with Build Start:</strong> Contact us at{" "}
                                <a
                                    href="mailto:help@buildstart.au"
                                    className={termStyles.link}
                                >
                                    help@buildstart.au
                                </a>
                            </li>
                        </ul>

                        <p>
                            We strive to resolve issues within 7 days.
                            If unresolved after 30 days, both parties agree to
                            formal mediation in Australia before initiating court proceedings.
                        </p>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>12. Apple App Store Additional Terms</h2>

                        <ul>
                            <li>
                                <strong>Acknowledgment:</strong> These Terms are between
                                you and Build Start only, not Apple.
                            </li>

                            <li>
                                <strong>Account Deletion:</strong> Users may initiate
                                permanent account deletion from within the App Settings.
                            </li>

                            <li>
                                <strong>Third-Party Beneficiary:</strong> Apple and its
                                subsidiaries have the right to enforce these Terms.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>13. Google Play Store Additional Terms</h2>

                        <ul>
                            <li>
                                <strong>Billing:</strong> Digital subscriptions are handled
                                via Google’s billing system where applicable.
                            </li>

                            <li>
                                <strong>UGC Policy:</strong> We provide in-app tools
                                for users to report abusive behaviour or inappropriate content.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>14. Payment Processing (Stripe Terms)</h2>

                        <ul>
                            <li>
                                <strong>Service Provider:</strong> Payment processing services
                                are provided by Stripe under the Stripe Connected Account Agreement.
                            </li>

                            <li>
                                <strong>Onboarding:</strong> Pros authorise Build Start
                                to share business information with Stripe for payment processing.
                            </li>

                            <li>
                                <strong>Chargebacks:</strong> Pros are responsible for
                                chargebacks or disputes regarding subscription fees.
                            </li>
                        </ul>
                    </div>

                    <div className={termStyles.policySection}>
                        <h2>15. Contact Us</h2>

                        <p>
                            For questions regarding these Terms, please contact:
                        </p>

                        <p>
                            <a
                                href="mailto:help@buildstart.au"
                                className={termStyles.link}
                            >
                                help@buildstart.au
                            </a>
                        </p>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default TermsAndConditions;